import { ChipArrayField } from 'admin/fields/ChipArrayField';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { Datagrid, DateField, DeleteButton, EditButton, ReferenceField, SelectField, TextField } from 'react-admin';

import { SERVICE_AREA_TYPES, USER_RELATION_TYPES } from './userRelationUtils';

export const UserRelationSimpleDatagrid: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  const showEditButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);
  const showDeleteButton = hasAnyRole([Role.RoleFinancialAdvisor, Role.RoleAdmin]);

  return (
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ReferenceField label="Kto" link="show" reference="User" source="subjectUser.id">
        <TextField source="email" />
      </ReferenceField>
      <SelectField choices={USER_RELATION_TYPES} label="Vzťah" source="relationType" />
      <ChipArrayField choices={SERVICE_AREA_TYPES} label="V oblastiach" source="serviceAreas" />
      <DateField label="Dátum vytvorenia" locales="sk" source="creationTimestamp" />
      <DateField label="Dátum zmeny" locales="sk" source="updateTimestamp" />
      {showEditButton && <EditButton />}
      {showDeleteButton && <DeleteButton mutationMode="pessimistic" />}
    </Datagrid>
  );
};
